
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic05Off as ObiLogic05OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-05-off.js';
 
 
 

 
 export const ObiLogic05Off = createComponent({
   react: React,
   tagName: 'obi-logic-05-off',
   elementClass: ObiLogic05OffElement,
   events: {
     
   }
  });
 
 